// src/components/pickers/TipFacturaIntrarePickerModal.jsx
import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Form, Table, Spinner, Alert } from "react-bootstrap";
import api from "../../axiosConfig";

export default function TipFacturaIesirePickerModal({
  show,
  onHide,
  onPick,
  initialQuery = "",
  minChars = 0,
  title = "Alege clasificarea fiscală",
}) {
  const [q, setQ] = useState(initialQuery);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(null);
  const [page, setPage] = useState(1);

  const limit = 20;
  const inputRef = useRef(null);

  const fetchPage = async (nextPage = 1, query = q) => {
    const qq = (query || "").trim();

    if (qq.length < minChars && qq.length > 0) {
      setItems([]);
      setTotal(null);
      setPage(1);
      setErr("");
      return;
    }

    setBusy(true);
    setErr("");

    try {
      const skip = (nextPage - 1) * limit;

      const res = await api.get("/tip_factura_iesire", {
        params: {
          skip,
          limit,
          ...(qq ? { search: qq } : {}),
        },
      });

      const data = res.data;
      const list = Array.isArray(data) ? data : data?.items || [];
      const t = Array.isArray(data) ? list.length : (data?.total ?? null);

      const mapped = list.map((it) => {
        const id = it.bxid ?? it.id;
        const name = it.tip_factura ?? it.denumire ?? it.name ?? "";
        const labels = {1: "Normală", 2: "Agenții de turism", 3: "Emisă de un terț în numele meu", 4: "Notă de creditare / reducere", 5: "Factură simplificată", 6: "Bunuri second-hand", 7: "Nu se raportează în D394"};
        const label = labels[Number(id)] || (name || `#${id}`).trim();
        return { id, label, raw: it };
      });

      setItems(mapped);
      setTotal(t);
      setPage(nextPage);
    } catch (e) {
      setErr(e?.response?.data?.detail || e?.message || String(e));
      setItems([]);
      setTotal(null);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    if (!show) return;

    const init = (initialQuery || "").trim();
    setQ(init);
    setItems([]);
    setTotal(null);
    setPage(1);
    setErr("");

    fetchPage(1, "");
    setTimeout(() => inputRef.current?.focus(), 50);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const hasMore = total != null ? page * limit < total : items.length === limit;

  const pick = (opt) => {
    if (!opt) return;
    onPick?.({ id: opt.id, label: opt.label, raw: opt.raw });
    onHide?.();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {err && <Alert variant="danger">{err}</Alert>}

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            fetchPage(1, q);
          }}
        >
          <div className="d-flex gap-2">
            <Form.Control
              ref={inputRef}
              autoFocus
              placeholder={
                minChars >= 2
                  ? `Caută tip factură... (minim ${minChars} caractere, Enter)`
                  : "Caută tip factură... (Enter)"
              }
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
            <Button type="submit" disabled={busy}>
              Caută
            </Button>
          </div>
        </Form>

        <div className="mt-3">
          {busy ? (
            <div className="d-flex align-items-center gap-2">
              <Spinner size="sm" />
              <span>Se încarcă...</span>
            </div>
          ) : (
            <>
              <Table hover size="sm" className="mb-0">
                <tbody>
                  {items.map((it) => (
                    <tr
                      key={String(it.id)}
                      role="button"
                      onClick={() => pick(it)}
                      style={{ cursor: "pointer" }}
                    >
                      <td style={{ width: 120, whiteSpace: "nowrap" }}>
                        #{it.id}
                      </td>
                      <td>{it.label}</td>
                    </tr>
                  ))}

                  {items.length === 0 && (
                    <tr>
                      <td className="text-muted">
                        {(q || "").trim().length < minChars
                          ? "Tastează și apasă Enter pentru căutare."
                          : "Nimic găsit."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <div className="d-flex justify-content-between align-items-center mt-2">
                <div className="text-muted" style={{ fontSize: 12 }}>
                  {total != null ? `Total: ${total}` : ""}
                </div>

                <div className="d-flex gap-2">
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    disabled={busy || page <= 1}
                    onClick={() => fetchPage(page - 1, q)}
                  >
                    Înapoi
                  </Button>

                  <Button
                    size="sm"
                    variant="outline-secondary"
                    disabled={busy || !hasMore}
                    onClick={() => fetchPage(page + 1, q)}
                  >
                    Înainte
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Închide
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
